/**
 * Session 20 — OCPP 1.6J FirmwareManagement outbound (CP → CSMS):
 *   - FirmwareStatusNotification   — firmware-update lifecycle progress.
 *   - DiagnosticsStatusNotification — diagnostics-upload progress.
 * Both carry a single `status` field per the 1.6J schemas.
 */

export type V16FirmwareStatus =
  | 'Downloaded'
  | 'DownloadFailed'
  | 'Downloading'
  | 'Idle'
  | 'InstallationFailed'
  | 'Installing'
  | 'Installed';

export type V16DiagnosticsStatus = 'Idle' | 'Uploaded' | 'UploadFailed' | 'Uploading';

export function buildFirmwareStatusNotificationRequest(
  status: V16FirmwareStatus,
): Record<string, unknown> {
  return { status };
}

export function buildDiagnosticsStatusNotificationRequest(
  status: V16DiagnosticsStatus,
): Record<string, unknown> {
  return { status };
}
